import { Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import * as Yup from 'yup';
import PlansState from '../Context/state';
import { InputSwitch } from 'primereact/inputswitch';

const ModalEditPlan = ({ planDialog, plan, hideDialog }) => {
    const { EditPlans } = PlansState();

    const UserSchema = Yup.object().shape({
        name: Yup.string().min(2, 'Muito Curto!').max(50, 'Muito Longo!').required('Campo Obrigatório'),
        price: Yup.number().required('Campo Obrigatório'),
        numberZones: Yup.number().required('Campo Obrigatório'),
        maxSize: Yup.number().required('Campo Obrigatório')
    });

    console.log(plan);

    return (
        <Dialog visible={planDialog} style={{ width: '450px' }} header="Detalhes do plano" modal className="p-fluid" onHide={hideDialog}>
            <Formik
                validationSchema={UserSchema}
                initialValues={{
                    planId: plan?.id,
                    name: plan?.name,
                    price: plan?.price || 0,
                    numberZones: plan?.numberZones || 0,
                    maxSize: plan?.maxSize || 0,
                    zoneMembers: plan?.zoneMembers || 0,
                    artificialIntelligence: plan?.artificialIntelligence,
                    isZoneIntelligence: plan?.isZoneIntelligence,
                    isBusiness: plan?.isBusiness,
                    viewd: plan?.viewd
                }}
                onSubmit={(values) => {
                    EditPlans(values, hideDialog);
                }}
            >
                {({ values, handleChange, errors, touched, handleSubmit }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <div className="field">
                                <label htmlFor="name">Name</label>
                                <InputText name="name" id="name" value={values?.name} onChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.name && touched.name })} />
                                {errors.name && touched.name && <small className="p-invalid">{errors.name}</small>}
                            </div>
                            {/* <div className="field">
                                <label htmlFor="name">Preço</label>
                                <InputNumber mode="currency" currency="BRL" locale="pt-BR" name="price" id="price" value={values?.price} onValueChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.price && touched.price })} />
                                {errors.price && touched.price && <small className="p-invalid">{errors.price}</small>}
                            </div> */}
                            <div className="grid field gap-4 ml-1 ">
                                <div className="field" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="name">Possui IA?</label>
                                    <InputSwitch checked={values.artificialIntelligence === true} name="artificialIntelligence" onChange={handleChange} value={values.artificialIntelligence} />
                                    {errors.artificialIntelligence && touched.artificialIntelligence && <small className="p-invalid">{errors.artificialIntelligence}</small>}
                                </div>
                                <div className="field" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="name">Business?</label>
                                    <InputSwitch checked={values.isBusiness === true} name="isBusiness" onChange={handleChange} value={values.isBusiness} />
                                    {errors.isBusiness && touched.isBusiness && <small className="p-invalid">{errors.isBusiness}</small>}
                                </div>
                                <div className="field" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="name">Zona inteligente?</label>
                                    <InputSwitch checked={values.isZoneIntelligence === true} name="isZoneIntelligence" onChange={handleChange} value={values.isZoneIntelligence} />
                                    {errors.isZoneIntelligence && touched.isZoneIntelligence && <small className="p-invalid">{errors.isZoneIntelligence}</small>}
                                </div>
                                <div className="field" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="name">Visível?</label>
                                    <InputSwitch checked={values.viewd === true} name="viewd" onChange={handleChange} value={values.viewd} />
                                    {errors.viewd && touched.viewd && <small className="p-invalid">{errors.viewd}</small>}
                                </div>
                            </div>
                            <div className="field">
                                <label htmlFor="name">Nº de Zonas</label>
                                <InputNumber
                                    showButtons
                                    name="numberZones"
                                    id="numberZones"
                                    value={values?.numberZones}
                                    onValueChange={handleChange}
                                    required
                                    autoFocus
                                    className={classNames({ 'p-invalid': errors.numberZones && touched.numberZones })}
                                />
                                {errors.numberZones && touched.numberZones && <small className="p-invalid">{errors.numberZones}</small>}
                            </div>
                            <div className="field">
                                <label htmlFor="name">Tamanho máximo</label>
                                <InputNumber showButtons name="maxSize" id="maxSize" value={values?.maxSize} onValueChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.maxSize && touched.maxSize })} />
                                {errors.maxSize && touched.maxSize && <small className="p-invalid">{errors.maxSize}</small>}
                            </div>
                            <div className="field">
                                <label htmlFor="name">Nº de membros</label>
                                <InputNumber
                                    showButtons
                                    name="zoneMembers"
                                    id="zoneMembers"
                                    value={values?.zoneMembers}
                                    onValueChange={handleChange}
                                    required
                                    autoFocus
                                    className={classNames({ 'p-invalid': errors.zoneMembers && touched.zoneMembers })}
                                />
                                {errors.zoneMembers && touched.zoneMembers && <small className="p-invalid">{errors.zoneMembers}</small>}
                            </div>

                            <div className="p-5"></div>
                            <div className="flex align-items-center justify-content-end">
                                <div className=" w-6 flex align-items-center justify-content-end">
                                    <Button label="Cancel" type="button" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                                    <Button label="Save" type="submit" icon="pi pi-check" className="p-button-text" />
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

export default ModalEditPlan;
